import Phaser from 'phaser';
import { CST } from '../CST';
import $ from 'jquery';
import buttonBehaviours from '../helpers/button-behaviours';
import { hideTextFields, showTextFields } from '../helpers/text-fields';

export default class SignUpOrg extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.SIGNUP_ORG);
	}

	preload() {
		this.load.image('bg-register-org', 'assets/bg-register-org.png');
		this.load.image('btn-sign-up', 'assets/btn-sign-up.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('error-account-exists', 'assets/english/error/error-account-exists.png');
		this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
		this.load.image('error-generic', 'assets/english/error/error-generic.png');
		this.load.image('error-invalid-email', 'assets/english/error/error-invalid-email.png');
		this.load.image('error-passwords-not-match', 'assets/english/error/error-passwords-not-match.png');
		this.load.html('html-first-name', 'html/first-name.html');
		this.load.html('html-last-name', 'html/last-name.html');
		this.load.html('html-org-name', 'html/organisation-name.html');
		this.load.html('html-email', 'html/email.html');
		this.load.html('html-password', 'html/password.html');
		this.load.html('html-password-confirmation', 'html/password-confirmation.html');
	}

	create() {
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-register-org');

		this.firstName = this.add
			.dom(this.cameras.main.width / 2 - 215, this.cameras.main.height / 2 - 170)
			.createFromCache('html-first-name');
		this.firstName = this.firstName.getChildByName('firstName');

		this.lastName = this.add
			.dom(this.cameras.main.width / 2 + 195, this.cameras.main.height / 2 - 170)
			.createFromCache('html-last-name');
		this.lastName = this.lastName.getChildByName('lastName');

		this.orgNameDom = this.add
			.dom(this.cameras.main.width / 2 - 215, this.cameras.main.height / 2 - 85)
			.createFromCache('html-org-name');
		this.orgNameInput = this.orgNameDom.getChildByName('organisationName');

		this.email = this.add
			.dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 + 5)
			.createFromCache('html-email');
		this.email = this.email.getChildByName('email');

		this.password = this.add
			.dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 + 90)
			.createFromCache('html-password');
		this.password = this.password.getChildByName('password');

		this.passwordConfirmation = this.add
			.dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 + 180)
			.createFromCache('html-password-confirmation');
		this.passwordConfirmation = this.passwordConfirmation.getChildByName('passwordConfirmation');

		// this.productCode = this.add
		// 	.dom(this.cameras.main.width / 2 - 90, this.cameras.main.height / 2 + 270)
		// 	.createFromCache('html-product-code');
		// this.productCode = this.productCode.getChildByName('productCode');

		this.btnSignUp = this.add
			.image(
				this.cameras.main.width / 2 /*+ 150*/,
				this.cameras.main.height / 2 + 370,
				'btn-sign-up',
			)
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnSignUp, () => {
					this.signUp();
				}),
			);

		// this.btnBuyNow = this.add
		// 	.image(this.cameras.main.width / 2 - 150, this.cameras.main.height / 2 + 370, 'btn-buy-now')
		// 	.setInteractive({ useHandCursor: true })
		// 	.on('pointerdown', () =>
		// 		buttonBehaviours.pushOnClick(this, this.btnBuyNow, () => {
		// 			window.open(
		// 				'https://shop.focusgames.com/products/leadership-roulette?_pos=3&_psq=leadership&_ss=e&_v=1.0',
		// 				'_blank',
		// 			);
		// 		}),
		// 	);

		this.btnBack = this.add
			.image(90, this.cameras.main.height / 2 + 410, 'back_btn')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnBack, () => {
					this.scene.start(CST.SCENES.REGISTER_CHOOSE);
				}),
			)
			.setScale(1.5);
	}

	signUp() {
		let self = this;

		const orgFields = [this.orgNameInput];

		$.ajax({
			async: false,
			type: 'post',
			url: 'website/register.php',
			data: {
				firstName: this.firstName.value,
				lastName: this.lastName.value,
				email: this.email.value,
				password: this.password.value,
				passwordConfirmation: this.passwordConfirmation.value,
				// productCode: this.productCode.value,
				accountType: 'organisation',
				organisationName: this.orgNameInput.value,
			},
			dataType: 'JSON',
			success(response) {
				if (response[0] === 400) {
					hideTextFields([
						self.firstName,
						self.lastName,
						...orgFields,
						self.email,
						self.password,
						self.passwordConfirmation,
						// self.productCode,
					]);

					buttonBehaviours.disableInteraction([self.btnSignUp, self.btnBack]);

					const error = self.add.image(
						self.cameras.main.width / 2,
						self.cameras.main.height / 2 - 175,
						response[1],
					);

					setTimeout(() => {
						showTextFields([
							self.firstName,
							self.lastName,
							...orgFields,
							self.email,
							self.password,
							self.passwordConfirmation,
							// self.productCode,
						]);
						buttonBehaviours.enableInteraction([self.btnSignUp, self.btnBack]);

						error.destroy();
					}, 2000);
				} else {
					localStorage.setItem('jwt', response[1]);
					self.scene.start(CST.SCENES.MENU);
				}
			},
			error(error) {
				console.log(error);
			},
		}).responseJSON;
	}
}
